import React, { PureComponent } from 'react'
import { Trans } from 'react-i18next'
import './styles.scss'
import Bar from './Bar'
import PropTypes from 'prop-types'
class Bars extends PureComponent {
  render () {
    return (
      <div className={'Bars ' + this.props.className}>
        <div className="Bars-Values">
          <h3>{this.props.values.sum}</h3>
          <Trans>{this.props.values.sum_subline}</Trans>
        </div>
        <div className="Bars-Items">
          {this.props.values.values.map((bar, index) => {
            return (
              <Bar key={index} index={index + 1} value={bar.value} label={bar.label}></Bar>
            )
          })}
        </div>
      </div>
    )
  }
}
Bars.defaultProps = {}
Bars.propTypes = {
  className: PropTypes.string.isRequired,
  values: PropTypes.shape({
    // sum: PropTypes.string.isRequired,
    // sum_subline: PropTypes.string,
    values: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired
      })
    )
  })
}
export default Bars
